import { memo } from 'react';

type AsideProps = {
	id?: string;
	children?: React.ReactNode;
	className?: string;
};

const Aside = memo(({ id, children, className }: AsideProps) => (
	<aside
		className={`aside ${className ? className : ''}`}
		id={id}
	>
		{children}
	</aside>
));

Aside.displayName = 'Aside';

export { Aside };
